function InstallHandlebarsHelpers() {

    Handlebars.registerHelper({
        // Logical helpers
        eq: function (v1, v2) {
            return v1 === v2;
        },
        ne: function (v1, v2) {
            return v1 !== v2;
        },
        lt: function (v1, v2) {
            return v1 < v2;
        },
        gt: function (v1, v2) {
            return v1 > v2;
        },
        lte: function (v1, v2) {
            return v1 <= v2;
        },
        gte: function (v1, v2) {
            return v1 >= v2;
        },
        and: function () {
            return Array.prototype.slice.call(arguments).every(Boolean);
        },
        or: function () {
            return Array.prototype.slice.call(arguments, 0, -1).some(Boolean);
        },
        empty: function (list) {
            return !list || (!!list && list.length === 0);
        },
        not: function(a) {
            return !a;
        },
        // Appointment-Specific helpers
        atype: function (typeName) {
            if (!typeName) {
                console.warn("Cannot determine appointment type if parameters are invalid");
                return false;
            }
            if (currentEvent && currentEvent.appointmentType) {
                var at = currentEvent.appointmentType.toLowerCase();
                typeName = typeName.toLowerCase();

                return at === typeName;
            }
            return false;
        },
        // User-Specific helpers
        utype: function (roleName) {
            return window.calendarConfiguration.loginUserType.toLowerCase() === roleName.toLowerCase();
        },
        concat: function () {
            Array.prototype.pop.call(arguments); // Remove the argument automatically added by handlebars.
            return Array.prototype.join.call(arguments, ''); // Concatenate all remaining arguments.
        }
    });

    // Work around a fail in Safari that screws up rendering of check boxes
    Handlebars.registerPartial("checkboxStyled", Handlebars.compile($("#wizardTemplateCheckboxStyled").html()));
    Handlebars.registerPartial("checkboxVanilla", Handlebars.compile($("#wizardTemplateCheckboxVanilla").html()));

    var $iCalFloatingContainer = $('#iCalFloatingContainer');
    if ($iCalFloatingContainer.length) {
        Handlebars.registerPartial("iCalFloatingContainer", Handlebars.compile($iCalFloatingContainer.html()));
    }

    Handlebars.registerHelper("checkbox", function (inputName, inputId, inputValue, label, checked) {
        // Normalize input
        if (typeof checked === "string") {
            checked = checked.toLowerCase() === "true";
        }

        // Note: Only Safari 12 is affected, however all browsers based on WebKit contain Safari in the user agent
        // Also let's assume Apple gets their sh*t together with Safari 13
        var templateName = navigator.userAgent.indexOf("Mac OS X") !== -1 && navigator.userAgent.indexOf("Safari/") !== -1
            ? "checkboxVanilla"
            : "checkboxStyled";
        return Handlebars.partials[templateName]({
            inputName: inputName,
            inputId: inputId,
            inputValue: inputValue,
            checked: checked,
            label: label
        });
    });

    // Formatting helpers
    Handlebars.registerHelper("formatDate", function (date) {
        if (!date) {
            console.warn("Cannot format object as date string ", date);
            return "";
        }

        if (!(date instanceof moment)) {
            date = moment.parseZone(date);
        }

        return date.format('L LT');
    });

    Handlebars.registerHelper("formatDateTime", function (date, format) {
        if (!date) {
            console.warn("Cannot format object as date string ", date);
            return "";
        }

        if (!(date instanceof moment)) {
            date = moment.parseZone(date);
        }

        return date.format(format);
    });
    Handlebars.registerHelper("formatTime", function (date) {
        if (!date) {
            console.warn("Cannot format object as date string ", date);
            return "";
        }
        if (!(date instanceof moment)) {
            date = moment.parseZone(date);
        }
        return date.format('LT');
    });
    Handlebars.registerHelper("t", function (translationKey) {
        return $t(translationKey);
    });
    Handlebars.registerHelper('get_length', function (obj) {
        return obj.length;
    });

    Handlebars.registerHelper('for', function (from, to, incr, thisOffset, block) {
        var accum = '';
        for (var i = from; i < to; i += incr)
            accum += block.fn(i + thisOffset);
        return accum;
    });
}
